var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("h3", [_vm._v(_vm._s(_vm.$t("explore.heading")))]),
    _vm._v(" "),
    _c("ul", { staticClass: "nav nav-tabs" }, [
      _c(
        "li",
        {
          class: { active: _vm.exploreMode === "corpora" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.exploreMode = "corpora"
            },
          },
        },
        [
          _c("a", { attrs: { href: "#explore-corpora" } }, [
            _vm._v(_vm._s(_vm.$t("explore.corpora.heading"))),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.exploreMode === "ngram" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.exploreMode = "ngram"
            },
          },
        },
        [
          _c("a", { attrs: { href: "#explore-n-grams" } }, [
            _vm._v(_vm._s(_vm.$t("explore.ngram.heading"))),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.exploreMode === "frequency" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.exploreMode = "frequency"
            },
          },
        },
        [
          _c("a", { attrs: { href: "#explore-frequency" } }, [
            _vm._v(_vm._s(_vm.$t("explore.frequency.heading"))),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tab-content" }, [
      _c(
        "div",
        {
          class: [
            "tab-pane form-horizontal",
            { active: _vm.exploreMode === "corpora" },
          ],
          attrs: { id: "explore-corpora" },
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              {
                staticClass: "col-xs-4 col-md-2",
                attrs: { for: "corpora-group-by" },
              },
              [_vm._v(_vm._s(_vm.$t("explore.corpora.groupBy")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-8" },
              [
                _c("SelectPicker", {
                  staticStyle: { "max-width": "400px" },
                  attrs: {
                    placeholder: `${_vm.$t("explore.corpora.groupBy")}...`,
                    "data-id": "corpora-group-by",
                    "data-width": "100%",
                    hideEmpty: "",
                    allowHtml: "",
                    options: _vm.metadataGroupByOptions,
                  },
                  model: {
                    value: _vm.corporaGroupBy,
                    callback: function ($$v) {
                      _vm.corporaGroupBy = $$v
                    },
                    expression: "corporaGroupBy",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              {
                staticClass: "col-xs-4 col-md-2",
                attrs: { for: "corpora-display-mode" },
              },
              [_vm._v(_vm._s(_vm.$t("explore.corpora.showAs.heading")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-8" },
              [
                _c("SelectPicker", {
                  staticStyle: { "max-width": "400px" },
                  attrs: {
                    placeholder: _vm.$t("explore.corpora.showAs.heading"),
                    "data-id": "corpora-display-mode",
                    "data-width": "100%",
                    hideEmpty: "",
                    allowHtml: "",
                    options: _vm.corporaGroupDisplayModeOptions,
                  },
                  model: {
                    value: _vm.corporaGroupDisplayMode,
                    callback: function ($$v) {
                      _vm.corporaGroupDisplayMode = $$v
                    },
                    expression: "corporaGroupDisplayMode",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "tab-pane form-horizontal",
            { active: _vm.exploreMode === "ngram" },
          ],
          attrs: { id: "explore-n-grams" },
        },
        [
          _vm.isParallelCorpus
            ? _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-xs-4 col-md-2",
                    attrs: { for: "corpora-group-by" },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("search.parallel.searchSourceVersion"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xs-8" },
                  [
                    _c("ParallelSource", {
                      attrs: {
                        block: "",
                        lg: "",
                        errorNoParallelSourceVersion:
                          _vm.errorNoParallelSourceVersion,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              {
                staticClass: "col-xs-4 col-md-2",
                attrs: { for: "n-gram-size" },
              },
              [_vm._v(_vm._s(_vm.$t("explore.ngram.ngramSize")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-8 col-md-5" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.ngramSize,
                    expression: "ngramSize",
                    modifiers: { number: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  name: "n-gram-size",
                  id: "n-gram-size",
                  type: "number",
                  min: "1",
                  max: _vm.ngramSizeMax,
                },
                domProps: { value: _vm.ngramSize },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.ngramSize = _vm._n($event.target.value)
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              {
                staticClass: "col-xs-4 col-md-2",
                attrs: { for: "n-gram-type" },
              },
              [_vm._v(_vm._s(_vm.$t("explore.ngram.ngramType")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-8 col-md-5" },
              [
                _c("SelectPicker", {
                  attrs: {
                    "data-name": "n-gram-type",
                    "data-id": "n-gram-type",
                    "data-width": "100%",
                    hideEmpty: "",
                    allowHtml: "",
                    options: _vm.annotationGroupByOptions,
                  },
                  model: {
                    value: _vm.ngramType,
                    callback: function ($$v) {
                      _vm.ngramType = $$v
                    },
                    expression: "ngramType",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "n-gram-container" },
            _vm._l(_vm.ngramTokens, function (token, index) {
              return _c(
                "div",
                { key: index, staticClass: "n-gram-token" },
                [
                  _c("SelectPicker", {
                    attrs: {
                      "data-width": "100%",
                      "data-menu-width": "grow",
                      options: _vm.annotationSearchOptions,
                      disabled: index >= _vm.ngramSize,
                      value: token.id,
                      placeholder: "Property",
                      hideEmpty: "",
                      allowHtml: "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.updateTokenAnnotation(
                          index,
                          $event /* custom component - custom event values */
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  !token.annotation
                    ? _c("input", {
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          disabled: "",
                          title: "Please select an annotation to edit.",
                        },
                        domProps: { value: token.value },
                      })
                    : token.annotation.uiType === "select" ||
                      (token.annotation.uiType === "pos" &&
                        token.annotation.values)
                    ? _c("SelectPicker", {
                        attrs: {
                          "data-width": "100%",
                          "data-class": "btn btn-default",
                          "data-menu-width": "grow",
                          placeholder: _vm.$tAnnotDisplayName(token.annotation),
                          "data-dir": token.annotation.isMainAnnotation
                            ? _vm.mainTokenTextDirection
                            : undefined,
                          options: token.annotation.values,
                          disabled: index >= _vm.ngramSize,
                          value: token.value,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.updateTokenValue(index, $event)
                          },
                        },
                      })
                    : token.annotation.uiType === "lexicon"
                    ? _c("Lexicon", {
                        ref: "reset",
                        refInFor: true,
                        attrs: {
                          annotationId: token.annotation.id,
                          definition: token.annotation,
                          value: token.value,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.updateTokenValue(index, $event)
                          },
                        },
                      })
                    : _c("Autocomplete", {
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          useQuoteAsWordBoundary: "",
                          placeholder: _vm.$tAnnotDisplayName(token.annotation),
                          dir: token.annotation.isMainAnnotation
                            ? _vm.mainTokenTextDirection
                            : undefined,
                          disabled: index >= _vm.ngramSize,
                          url: _vm.autocompleteUrl(token.annotation),
                          value: token.value,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.updateTokenValue(index, $event)
                          },
                        },
                      }),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "tab-pane form-horizontal",
            { active: _vm.exploreMode === "frequency" },
          ],
          attrs: { id: "explore-frequency" },
        },
        [
          _vm.isParallelCorpus
            ? _c(
                "div",
                {
                  staticClass: "form-group form-group-lg",
                  staticStyle: { margin: "0" },
                },
                [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("search.parallel.searchSourceVersion"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("ParallelSource", {
                    attrs: {
                      block: "",
                      lg: "",
                      errorNoParallelSourceVersion:
                        _vm.errorNoParallelSourceVersion,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group form-group-lg",
              staticStyle: { margin: "0" },
            },
            [
              _c(
                "label",
                {
                  staticClass: "control-label",
                  attrs: { for: "frequency-type" },
                },
                [_vm._v(_vm._s(_vm.$t("explore.frequency.frequencyType")))]
              ),
              _vm._v(" "),
              _c("SelectPicker", {
                attrs: {
                  "data-id": "frequency-type",
                  "data-name": "frequency-type",
                  "data-width": "100%",
                  hideEmpty: "",
                  allowHtml: "",
                  options: _vm.annotationGroupByOptions,
                },
                model: {
                  value: _vm.frequencyType,
                  callback: function ($$v) {
                    _vm.frequencyType = $$v
                  },
                  expression: "frequencyType",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }